import React, { useEffect, useState, useCallback, useRef, memo } from "react";
import {
  Input,
  Button,
  Spinner,
} from "reactstrap";
import styles from "./hyperlink.module.css"

import widgetHyperlink from "../../../assets/images/icons-component/hyperlink.png";

import {
  getUrlParameter
} from "../../../utils/actions";
import {
  getAuthToken,
  getTeacherAuthToken,
} from "../../../utils/auth";

import { screenState, setError } from "../../../store/screen/slice";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";

const Index = (props: any) => {
  const { username } = useAppSelector(state => screenState(state));
  const dispatch = useAppDispatch();
  const { config, boxRef, onUpdate, actionEnd, setCanCopy } = props;
  const inputRef = useRef<any>(null);
  const [link, setLink] = useState("");
  const [data, setData] = useState<any[]>(config.data.linkList);
  const [Status, setStatus] = useState<any>("0");

  let accessToken = "";
  let token = null;
  if (getAuthToken()) {
    token = getAuthToken();
  } else if (getTeacherAuthToken()) {
    token = getTeacherAuthToken();
  }
  if (token) {
    accessToken = token;
  }
  
  useEffect(() => {
    if (Status === "1") {
      boxRef.current.style.height = `${data.length * (boxRef.current.style.width / 3.5)}px`;
      onUpdate({ id: config.id, height: data.length * (config.width / 3.5), baseHeight: data.length * 90 });
    }    
  }, [Status]);

  useEffect(() => {
    const DATA = config.data;
    if (config.data?.triggered) {
      setData(DATA.linkList);
      delete config.data.triggered;
    } else if (config.data && config.data.linkList) {
      DATA.linkList = data;
      const listTitle = data.length > 0 && data[0].title !== ""? data[0].title : link;
      const update: any = { id: config.id, data: DATA };
      if (listTitle !== "") {
        update["listTitle"] = listTitle;
      }
      if ((!username && !config?.studentName) || username === config.studentName) {
        onUpdate(update);
        actionEnd(true);
      }
    }
  }, [data, config.data]);

  async function getLinkPreviewData() {
    const BoardId = getUrlParameter("board");
    const apiUrl = `${process.env.REACT_APP_API_URL}/api/elements/url/${BoardId}`;
    
    setStatus("2");
    fetch(apiUrl, {
      method:"POST",
      headers: {
        "userToken": `${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        "url": link
      })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status != "SUCCESS") {        
        const linkData = { title: "", icon: "", link: link, pending: false, isOpen: true }
        setData([linkData]);
        setStatus("1");
        throw data;
      } else {
        const linkData = { ...data.data, link: link, pending: false, isOpen: true }
        setData([linkData]);
        setStatus("1");
      }
    })
    .catch(e => {
      console.log("error", e);
      const linkData = { title: "", icon: "", link: link, pending: false, isOpen: true }
      setData([linkData]);
      setStatus("1");

      dispatch(setError("連結資訊取得失敗"));
    });
  }

  const isValidUrl = () => {
    const urlWithoutFragment = link.split('#')[0];
    const urlPattern = new RegExp("^(?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?!(?:10|127)(?:\\.\\d{1,3}){3})(?!(?:169\\.254|192\\.168)(?:\\.\\d{1,3}){2})(?!172\\.(?:1[6-9]|2\\d|3[0-1])(?:\\.\\d{1,3}){2})(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z0-9\\u00a1-\\uffff][a-z0-9\\u00a1-\\uffff_-]{0,62})?[a-z0-9\\u00a1-\\uffff]\\.)+(?:[a-z\\u00a1-\\uffff]{2,}\\.?))(?::\\d{2,5})?(?:[/?#]\\S*)?$","i")
    return !!urlPattern.test(urlWithoutFragment);
  }

  return (
    <React.Fragment>
      <div className="" style={{ height: '100%', width: '100%', position: 'absolute' }}>
        {data.length !== 0? (
          <React.Fragment>
            {(data || []).map((item: any, index: any) => (
              <div className="ts-hyperlink py-[10px] px-[20px] d-flex flex-row align-items-center justify-content-between h-100" key={index}>
                <div className="overflow-hidden rounded d-flex align-items-center justify-content-center bg-screen" style={{ minHeight: "50px", minWidth: "50px" }}>
                  {item.link !== ""? (
                    <React.Fragment>
                      {item.icon !== ""? (
                        <img src={`data:image/jpeg;base64, ${item.icon}`} alt="" style={{ height: "20px", width: "20px" }} />
                      ) : (
                        <svg fill="none" viewBox="0 0 50 50" className="text-indigo-300">
                          <g id="fallback">
                            <rect id="Background" width="50" height="50" fill="white" rx="4"></rect>
                            <g id="Globe">
                              <path id="Vector" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                d="M25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z">
                              </path>
                              <path id="Vector_2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                d="M18 25C18 32.0237 20.3327 38.2973 23.999 42.5291C24.1264 42.6776 24.2811 42.7961 24.4534 42.8771C24.6257 42.9582 24.8118 43 25 43C25.1882 43 25.3743 42.9582 25.5466 42.8771C25.7189 42.7961 25.8736 42.6776 26.001 42.5291C29.6673 38.2973 32 32.0237 32 25C32 17.9763 29.6673 11.7027 26.001 7.47085C25.8736 7.32243 25.7189 7.20395 25.5466 7.1229C25.3743 7.04185 25.1882 7 25 7C24.8118 7 24.6257 7.04185 24.4534 7.1229C24.2811 7.20395 24.1264 7.32243 23.999 7.47085C20.3327 11.7027 18 17.9763 18 25Z">
                              </path>
                              <path id="Vector_3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                d="M8.73108 19.25H41.2689"></path>
                              <path id="Vector_4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                                d="M8.73108 30.75H41.2689"></path>
                            </g>
                          </g>
                        </svg>
                      )}
                    </React.Fragment>
                  ) : (
                    <svg fill="none" viewBox="0 0 50 50" className="text-indigo-300">
                      <g id="fallback-disconnected">
                        <rect id="Background" width="50" height="50" fill="white" rx="4"></rect>
                        <g id="Globe">
                          <path id="Vector" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                            d="M25 43C34.9411 43 43 34.9411 43 25C43 15.0589 34.9411 7 25 7C15.0589 7 7 15.0589 7 25C7 34.9411 15.0589 43 25 43Z">
                          </path>
                          <path id="Vector_2" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                            d="M18 25C18 32.0237 20.3327 38.2973 23.999 42.5291C24.1264 42.6776 24.2811 42.7961 24.4534 42.8771C24.6257 42.9582 24.8118 43 25 43C25.1882 43 25.3743 42.9582 25.5466 42.8771C25.7189 42.7961 25.8736 42.6776 26.001 42.5291C29.6673 38.2973 32 32.0237 32 25C32 17.9763 29.6673 11.7027 26.001 7.47085C25.8736 7.32243 25.7189 7.20395 25.5466 7.1229C25.3743 7.04185 25.1882 7 25 7C24.8118 7 24.6257 7.04185 24.4534 7.1229C24.2811 7.20395 24.1264 7.32243 23.999 7.47085C20.3327 11.7027 18 17.9763 18 25Z">
                          </path>
                          <path id="Vector_3" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                            d="M8.73108 19.25H41.2689"></path>
                          <path id="Vector_4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="3"
                            d="M8.73108 30.75H41.2689"></path>
                        </g>
                        <g id="Warning">
                          <path id="Vector_5" fill="#FACC15"
                            d="M35.1258 30.1422L41.9586 42.007C42.4375 42.843 41.8187 43.875 40.8328 43.875H27.1672C26.1812 43.875 25.5625 42.843 26.0414 42.007L32.8742 30.1422C33.3664 29.2859 34.6336 29.2859 35.1258 30.1422Z">
                          </path>
                          <path id="Vector_6" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                            d="M42.8252 41.508L42.8263 41.5099C43.7085 43.0499 42.5435 44.875 40.8328 44.875H27.1672C25.4565 44.875 24.2914 43.0499 25.1737 41.5099L25.1748 41.508L32.0072 29.6438C32.0073 29.6438 32.0073 29.6437 32.0073 29.6437C32.8839 28.119 35.1154 28.1188 35.9923 29.6431L42.8252 41.508ZM42.8252 41.508L35.9927 29.6438L42.8252 41.508Z">
                          </path>
                          <path id="Vector_7" stroke="white" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"
                            d="M34 38.25V35.125"></path>
                          <path id="Vector_8" fill="white"
                            d="M34 42C34.5178 42 34.9375 41.5803 34.9375 41.0625C34.9375 40.5447 34.5178 40.125 34 40.125C33.4822 40.125 33.0625 40.5447 33.0625 41.0625C33.0625 41.5803 33.4822 42 34 42Z">
                          </path>
                        </g>
                      </g>
                    </svg>
                  )}
                </div>
                <div className="core-color -mt-[2px]" style={{ minWidth: "calc(100% - 120px)", marginLeft: "13px", marginRight: "12px" }}>
                  <div className="truncate fs-4 fw-bolder">{item.title}</div>
                  <div className="truncate fs-6 fw-medium">{item.link}</div>
                </div>
                <a 
                  className="hyper-btn core-btn rounded-circle d-flex align-items-center justify-content-center focus-visible:outline-none font-semibold inline-flex flex-row justify-center items-center focus-visible:ring-red-500 h-10 w-10 p-2 focus-visible:ring-offset-2 focus-visible:ring-2 crs-btn-dark cursor-pointer rounded-full crs-btn-theme-accent1 mt-[5px]"
                  href={item.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <i className="mdi mdi-arrow-top-right-thick fs-24"></i>
                </a>
              </div>
            ))}
          </React.Fragment>
        ) : (
          <>
            <div className="relative flex h-full flex-col items-center justify-center gap-6 p-6 bg-screen " style={{ cursor: 'auto' }}>
              <div className="widget-head text-area-head">
                <img src={widgetHyperlink} alt="" />
              </div>
              <textarea 
                ref={inputRef}
                style={{ resize: "none" }}
                className="ts-text-area h-100 !text-lg"
                onChange={e => setLink(e.target.value)}
                placeholder="輸入網址 或 連結"
                defaultValue={link}
                data-interaction-target-type="false"
                onFocus={() => {
                  setCanCopy(false);
                }}
                onBlur={() => {
                  setCanCopy(true);
                }}
              >
              </textarea>
              <Button
                color="primary"
                className={`ts-playBtn btn-load rounded-pill text-sm px-4 h-11 font-semibold ${ !isValidUrl()? "ts-disabled" : null }`}
                onClick={getLinkPreviewData}
                disabled={!isValidUrl()}
                data-interaction-target-type="false"
              >
                <div className="relative justify-center h-100 w-100">
                  {Status === "0"? (
                    <span>建立</span>
                  ) : Status === "2"? (
                    (
                      <span className="ts-load d-flex justify-center items-center">
                        <Spinner size="sm" className="flex-shrink-0"> Loading... </Spinner>
                      </span>
                    )
                  ) : null}
                </div>
              </Button>
            </div>
            {username !== config.studentName? (
              <div className="absolute h-100 w-100 top-0 start-0" style={{ zIndex: 2 }}></div>
            ) : null}
          </>
        )}
      </div>
    </React.Fragment>
  );
};

export default memo(Index);